import React, { useState } from "react";
import "../css/main.css";
import { Link } from "react-router-dom";

import AdmissionModal from "../pages/AdmissionModal"; // Import the modal component
import Principal from "../pages/Principal";

// Assets
import banner1 from "../asset/banner/SMG_Banner_1.jpg";
import banner2 from "../asset/banner/SMG_Banner_2.jpg";
import banner3 from "../asset/banner/SMG_Banner_3.jpg";
import banner4 from "../asset/banner/SMG_Banner_4.jpg";
import banner5 from "../asset/banner/SMG_Banner_5.jpg";
import attitude from "../asset/icons/Attitude icon.png";
import science from "../asset/icons/Science icon.png";
import creativity from "../asset/icons/Creativity icon.png";
import cultural from "../asset/icons/Cultural icon.png";
import excel from "../asset/banner_img.png";
import logo from "../asset/SMG Logo.png";
// import infrastructure from "../asset/icons/Infrastructure icon.png";
// import events from "../asset/icons/Events icon.png";
// import achievements from "../asset/icons/Achivements icon.png";
// import toppers from "../asset/icons/toppers.png";
// import activities from "../asset/icons/Acitvities icon.png";
// import facilities from "../asset/icons/Facilities.png";

const Home = () => {
  const [showModal, setShowModal] = useState(false);

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  return (
    <div>
      {/* Main Section */}
      <section id="main">
        <div
          id="carouselExampleSlidesOnly"
          className="carousel slide"
          data-bs-ride="carousel"
          data-bs-interval="3000" // optional: sets auto-slide every 3 seconds
        >
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img className="d-block w-100" src={banner1} alt="First slide" />
            </div>
            <div className="carousel-item">
              <img className="d-block w-100" src={banner2} alt="Second slide" />
            </div>
            <div className="carousel-item">
              <img className="d-block w-100" src={banner3} alt="Third slide" />
            </div>
            <div className="carousel-item">
              <img className="d-block w-100" src={banner4} alt="Fouth slide" />
            </div>
            <div className="carousel-item">
              <img className="d-block w-100" src={banner5} alt="Fifth slide" />
            </div>
          </div>
        </div>

        {/* Mobile Only Content */}
        <div className="mobile-main-message">
          <div className="center">
            <h1 className="main-heading">
              Let your <span className="headred">Children </span>
              learn from the best.
            </h1>
            <p className="main-para">
              We help your children study better at their own pace.
            </p>
            <p className="main-para">
              Join us in our mission to create a better future for kids.
            </p>
            <button
              className="custom-btn"
              type="button"
              aria-label="Enroll now"
              onClick={() => {
                const target = document.getElementById("highlight");
                if (target) {
                  target.scrollIntoView({ behavior: "smooth" });
                }
              }}
            >
              Explore More
            </button>
          </div>
        </div>
      </section>

      {/* Highlight Section */}
      {/* <HighlightSection /> */}
      <section id="highlight">
        <div className="container">
          <div className="row">
            {[
              {
                icon: attitude,
                title: "Attitude",
                subText: "Character Building",
                details:
                  "Fostering positive attitudes is the cornerstone of personal and social success. Our curriculum emphasizes building confidence, empathy, and integrity to nurture students into well-rounded individuals with strong moral values.",
              },
              {
                icon: science,
                title: "Science",
                subText: "Nature & Tech Learning",
                details:
                  "We ignite curiosity by blending nature and technology. Through hands-on experiments and innovative projects, students explore scientific concepts and develop critical thinking skills, preparing them for the future.",
              },
              {
                icon: creativity,
                title: "Creativity",
                subText: "Artistic Learning",
                details:
                  "Unlocking creativity is essential for innovation. Our programs inspire students to express themselves through art, music, and storytelling, nurturing imagination and problem-solving abilities.",
              },
              {
                icon: cultural,
                title: "Cultural",
                subText: "Culture Immersion and Values",
                details:
                  "Culture immersion fosters respect and understanding. Students celebrate diversity and learn about global traditions, shaping them into culturally aware individuals.",
              },
            ].map((item, index) => (
              <div key={index} className="col d-flex justify-content-center">
                <div className="box">
                  <div className="box-inner">
                    {/* Front Side */}
                    <div className="box-front">
                      <span className="box-icon">
                        <img
                          src={item.icon}
                          alt={`${item.title} Icon`}
                          className="img-fluid"
                        />
                      </span>
                      <h5 className="box-title">{item.title}</h5>
                      <p className="box-sub-text">{item.subText}</p>
                    </div>
                    {/* Back Side */}
                    <div className="box-back">
                      <p className="box-details">{item.details}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="abt">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="abt-left">
                <h2 className="abt-heading">
                  Empowering <br /> Minds for <br /> Tomorrow
                </h2>
                {/* <ScrollLink
                  className="custom-btn"
                  to="/about"
                  type="button"
                  aria-label="Read More"
                  smooth={true}
                  duration={500}
                >
                  Read More
                </ScrollLink> */}

                <Link
                  className="custom-btn"
                  to="/about"
                  type="button"
                  aria-label="Read More"
                  smooth={true}
                  duration={500}
                >
                  Know More
                </Link>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="abt-right">
                <p>
                  SMG English School was pioneered by the great visionary{" "}
                  <strong>Shri. Maruti U. Gaikar.</strong> It is the first
                  English medium school in Diva, established in 1993. Later, in
                  1998, Om Sai Shikshan Sanstha was established and certified by
                  the charity commission.
                </p>
                <p>
                  SMG English School first conducted pre-primary classes at
                  Dativali village, Diva. The journey of imparting education
                  began from his own residence at Sai Mauli Niwas, with only 36
                  students.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Excellence Section */}
      <section id="excellence">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="excel-left">
                <h2 className="excel-subtitle">Educational Excellence</h2>
                <h1 className="excel-title">Balanced Growth</h1>
                <p className="excel-para">
                  We educate the whole healthy child, including mental,
                  physical, and emotional development, through a balanced
                  curriculum that includes academics, arts, and sports while
                  incorporating character, personal, and life skills.
                </p>
                <div className="logo-container">
                  <img src={logo} alt="SMG LOGO" className="logo" />
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <img
                src={excel}
                alt="Educational Excellence"
                className="img-fluid"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <Principal />
    </div>
  );
};

export default Home;
